var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3337_167426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 40.0448C30.535 40.0448 39.3548 31.2249 39.3548 20.3451C39.3548 9.46533 30.535 0.645508 19.6552 0.645508C8.77539 0.645508 -0.0444336 9.46533 -0.0444336 20.3451C-0.0444336 31.2249 8.77539 40.0448 19.6552 40.0448Z",
    fill: "url(#paint0_linear_3337_167426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8403 9.40137H15.4789C11.7491 9.40137 8.71973 12.4307 8.71973 16.1605V24.5219C8.71973 28.2517 11.7491 31.2811 15.4789 31.2811H23.8403C27.5701 31.2811 30.5994 28.2517 30.5994 24.5219V16.1605C30.5994 12.4307 27.5701 9.40137 23.8403 9.40137ZM28.1567 24.5307C28.1567 26.9121 26.2217 28.8558 23.8315 28.8558H15.4701C13.0887 28.8558 11.145 26.9209 11.145 24.5307V16.1693C11.145 13.7878 13.0799 11.8441 15.4701 11.8441H23.8315C26.213 11.8441 28.1567 13.7791 28.1567 16.1693V24.5307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 14.751C16.5733 14.751 14.0605 17.2638 14.0605 20.3457C14.0605 23.4276 16.5733 25.9404 19.6552 25.9404C22.7371 25.9404 25.2499 23.4276 25.2499 20.3457C25.2499 17.2638 22.7371 14.751 19.6552 14.751ZM19.6552 23.7428C17.7816 23.7428 16.2581 22.2193 16.2581 20.3457C16.2581 18.472 17.7816 16.9486 19.6552 16.9486C21.5289 16.9486 23.0523 18.472 23.0523 20.3457C23.0523 22.2193 21.5289 23.7428 19.6552 23.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6761 15.3647C26.1915 15.2811 26.5416 14.7956 26.4581 14.2801C26.3745 13.7647 25.8889 13.4146 25.3735 13.4981C24.858 13.5817 24.5079 14.0673 24.5915 14.5827C24.675 15.0981 25.1606 15.4483 25.6761 15.3647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3337_167426",
    x1: 4.65537,
    y1: 35.3449,
    x2: 32.6507,
    y2: 7.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3337_167426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.3103,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6074b112a55040f76ffe0eec5d2f8993.svg";
export { ForwardRef as ReactComponent };